import React from 'react'

import type { BoxSummaryTreatmentProps } from './props'
import type { LoggedOutBoxSummaryController } from './types'
import { useLoggedOutBoxSummaryController } from './useLoggedOutBoxSummaryController'

type LoggedOutBoxSummaryModalProps = {
  controller: LoggedOutBoxSummaryController
}

// Dummy component - to be replaced with @features/box-summary
const LoggedOutBoxSummaryModalPlaceholder = ({ controller }: LoggedOutBoxSummaryModalProps) => {
  if (!controller.isOpen) {
    return null
  }

  return (
    <div data-testid="logged-out-box-summary-modal" data-step={controller.step}>
      <button type="button" onClick={controller.actions.onClose}>
        Close
      </button>
      <h2>{controller.views[controller.step].title}</h2>
    </div>
  )
}

export const BoxSummaryTreatment = (props: BoxSummaryTreatmentProps) => {
  const controller = useLoggedOutBoxSummaryController(props)

  return <LoggedOutBoxSummaryModalPlaceholder controller={controller} />
}
